<template>
  <div class="main-user-info">
    <div class="main-user-info__items">
      <property-item title="Фамилия" class="main-user-info__item">
        <skeleton-loader v-if="!user" width="100px" type="paragraph-m_h" />
        <div v-else>{{ user.profile?.lastName }}</div>
      </property-item>
      <property-item title="Имя" class="main-user-info__item">
        <skeleton-loader v-if="!user" width="100px" type="paragraph-m_h" />
        <div v-else>{{ user.profile?.name }}</div>
      </property-item>
      <property-item title="Отчество" class="main-user-info__item">
        <skeleton-loader v-if="!user" width="100px" type="paragraph-m_h" />
        <div v-else>{{ user.profile?.middleName || '-' }}</div>
      </property-item>
      <property-item title="Телефон" class="main-user-info__item">
        <phone-number v-if="user && user.profile?.phoneNumber" :value="user.profile.phoneNumber" />
        <skeleton-loader v-else width="100px" type="paragraph-m_h" />
      </property-item>
      <property-item title="Email" class="main-user-info__item">
        <skeleton-loader v-if="!user" width="100px" type="paragraph-m_h" />
        <div v-else>{{ user.email }}</div>
      </property-item>
      <div class="main-user-info__documents">
        <a :href="privacyPolicyPersonalData" target="_blank" class="link paragraph-s_h">Политика конфиденциальности</a>
        <a :href="privacyPolicy" target="_blank" class="link paragraph-s_h"
          >Согласие на обработку персональных данных</a
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Profile } from '@/parts/auth/store/auth';
import type { UserInfo } from '@/parts/users/types/users';
import PhoneNumber from '@/core/components/common/PhoneNumber.vue';
import PropertyItem from '@/core/components/interface/PropertyItem.vue';
import SkeletonLoader from '@/core/components/interface/SkeletonLoader.vue';
import { privacyPolicy, privacyPolicyPersonalData } from '@/core/consts/documents';

defineProps<{
  user: UserInfo | Profile | undefined;
}>();
</script>

<style scoped lang="scss">
.main-user-info {
  &__items {
    display: flex;
    flex-wrap: wrap;

    row-gap: 24px;
  }

  &__item {
    min-width: 176px;
    margin-right: 40px;

    @include sm-and-down {
      min-width: 160px;
    }
  }

  &__documents {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    max-width: 288px;

    @include md-and-down {
      max-width: 100%;
    }
  }
}
</style>
